import styled, { css } from 'styled-components';
import { theme } from 'styles';

const sizes = {
  small: css`
    width: 73px;
    height: 40px;
    border-radius: 8px;
  `,
  medium: css`
    padding: 13px 24px;
    border-radius: 8px;
  `,
  large: css`
    width: 100px;
    height: 30px;
    border-radius: 6px;
  `,
  control: css`
    width: 59px;
    height: 24px;
    border-radius: 12px;
  `,
  default: css`
    width: 100px;
    height: 40px;
    border-radius: 8px;
  `,
  free: css`
    padding: 12px 24px;
    border-radius: 8px;
  `,
};

const types = {
  standard: {
    enabled: css`
      background-color: ${theme.colors.primary600};
      color: #ffffff;
    `,
    hovered: css`
      background-color: ${theme.colors.primary400};
      color: #ffffff;
    `,
    focused: css`
      background-color: ${theme.colors.primary400};
      border: 2px solid ${theme.colors.primary500};
      color: #ffffff;
    `,
    pressed: css`
      background-color: ${theme.colors.primary600};
      color: #ffffff;
    `,
    disabled: css`
      background-color: ${theme.colors.primary};
      opacity: 0.2;
    `,
  },
  sub: {
    enabled: css`
      background-color: ${theme.colors.gray100};
      color: ${theme.colors.assistive};
    `,
    hovered: css`
      background-color: ${theme.colors.gray200};
      color: ${theme.colors.assistive};
    `,
    focused: css`
      background-color: ${theme.colors.gray200};
      border: 2px solid ${theme.colors.gray300};
      color: ${theme.colors.assistive};
    `,
    pressed: css`
      background-color: ${theme.colors.gray300};
      color: ${theme.colors.assistive};
    `,
    disabled: css`
      background-color: ${theme.colors.gray100};
      color: ${theme.colors.assistive};
      opacity: 0.2;
    `,
  },
  alert: {
    enabled: css`
      background-color: ${theme.colors.alert};
      color: #ffffff;
    `,
    hovered: css`
      background-color: ${theme.colors.alertHover};
      color: #ffffff;
    `,
    focused: css`
      background-color: ${theme.colors.alertHover};
      border: 2px solid ${theme.colors.alertHover};
      color: #ffffff;
    `,
    pressed: css`
      background-color: ${theme.colors.alertHover};
      color: #ffffff;
    `,
    disabled: css`
      background-color: ${theme.colors.alert};
      color: #ffffff;
      opacity: 0.2;
    `,
  },
  control: {
    enabled: css`
      background-color: ${theme.colors.primary50};
      color: ${theme.colors.primary};
    `,
    off: css`
      background-color: ${theme.colors.gray100};
      color: ${theme.colors.gray600};
    `,
  },
};

export const Btn = styled.button`
  ${({ $size }) => sizes[$size]}
  ${({ $type }) => types[$type].enabled}
  display:flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  overflow: hidden;
  font-size: ${({ $type }) => ($type !== 'control' ? '16px' : '18px')};
  line-height: 1;

  &:hover {
    ${({ $type }) => types[$type].hovered}
  }
  &:focus {
    ${({ $type }) => types[$type].focused}
  }
  &:active {
    ${({ $type }) => types[$type].pressed}
  }
  &:disabled {
    ${({ $type }) => types[$type].disabled}
  }
`;
